module.exports = new __parcel__URL__("user-testing.7caf0674.svg").toString();